import { render, staticRenderFns } from "./S3Image.vue?vue&type=template&id=10fe1f66"
import script from "./S3Image.vue?vue&type=script&setup=true&lang=js"
export * from "./S3Image.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports